/**
 * useForceLogoutWatcher
 * 백엔드가 Firestore `trippang_revoked_sessions/{session_id}` doc를 set 하는 즉시
 * 클라이언트 토큰을 삭제하고 로그인 화면으로 이동시킨다.
 *
 * 적용 범위: 사용자/세션 차단, black_ips/black_tokens 등록 시 즉시 강제 로그아웃.
 */
import { useEffect } from "react";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const REVOKED_SESSIONS_COLLECTION = "trippang_revoked_sessions";

const KEYS_TO_CLEAR = [
  "access_token",
  "refresh_token",
  "user_id",
  "uid",
  "nick_name",
  "my_role",
  "session_id",
  "fcm_token",
];

export function useForceLogoutWatcher() {
  useEffect(() => {
    const sessionId = localStorage.getItem("session_id");
    if (!sessionId) return;

    const unsubscribe = onSnapshot(
      doc(db, REVOKED_SESSIONS_COLLECTION, sessionId),
      (snap) => {
        if (!snap.exists()) return;
        // 차단 시그널 수신 → 즉시 정리
        KEYS_TO_CLEAR.forEach((k) => localStorage.removeItem(k));
        // 새로고침 시 로그인 상태 자동 사라짐
        window.location.href = "/";
      },
      (e) => console.warn("[ForceLogout] watcher snapshot:", e)
    );
    return () => unsubscribe();
  }, []);
}
